import { AI_API_SERVICE } from '@eggplant/api-hosts'
import { AuthenticatedDataRequest } from '@eggplant/data-request'
import type { AiStatusResponse } from '@eggplant/types'
import type { ReactElement } from 'react'

interface Props {
  children?: (data: AiStatusResponse) => ReactElement
}

const GetAiStatusRequest = ({
  children
}: Props) => {
  const url = `${AI_API_SERVICE}/status`

  return (
    <AuthenticatedDataRequest
      children={children}
      method='get'
      url={url}
    />
  )
}

export default GetAiStatusRequest
